<ng-template iCmsUtilViewContainer></ng-template>
@for(component of printableComponents; track $index) {
<icms-component [data]="component"
                [outletOptions]="options" />
}